module.exports = __webpack_public_path__ + "static/img/bofangluxiang2.f7ab26a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/bofangluxiang2.png
// module id = 56GG
// module chunks = 24